import { Link } from 'react-router-dom';
import Card from '../ui/Card';
import { IconClock } from '../ui/icons';

export default function StuckCandidatesCard({ stuck }) {
  if (!stuck || stuck.count === 0) {
    return (
      <Card>
        <h3 className="mb-1 flex items-center gap-2 text-sm font-semibold text-gray-900">
          <IconClock className="h-4 w-4 text-gray-400" />
          Stuck candidates
        </h3>
        <p className="text-sm text-gray-500">No candidates have been stalled on a step for 14+ days.</p>
      </Card>
    );
  }

  return (
    <Card className="!border-amber-200 !bg-amber-50">
      <div className="mb-3 flex items-center justify-between">
        <h3 className="flex items-center gap-2 text-sm font-semibold text-amber-900">
          <IconClock className="h-4 w-4 text-amber-500" />
          {stuck.count} candidate{stuck.count === 1 ? '' : 's'} stuck 14+ days
        </h3>
        <Link to="/candidates?status=in_progress" className="text-xs font-medium text-amber-800 hover:underline">
          View all
        </Link>
      </div>
      <ul className="space-y-1.5">
        {stuck.top.map((c) => (
          <li key={c.id} className="flex items-center justify-between text-sm">
            <Link to={`/candidates/${c.id}`} className="text-amber-900 hover:underline">
              {c.reference_no} — {c.full_name}
            </Link>
            <span className="text-xs text-amber-700">
              {c.current_step} · {c.days_stuck}d
            </span>
          </li>
        ))}
      </ul>
    </Card>
  );
}
